import {
  WiDaySunny,
  WiNightClear,
  WiDayCloudy,
  WiNightAltCloudy,
  WiCloudy,
  WiRain,
  WiSnow,
  WiSleet,
  WiThunderstorm,
  WiFog,
  WiStrongWind,
  WiSnowflakeCold,
} from 'react-icons/wi';
import type { WeatherIcon as WeatherIconType } from '@miweather/shared';

interface WeatherIconProps {
  icon: WeatherIconType;
  size?: number;
  className?: string;
}

export function WeatherIcon({ icon, size = 32, className = '' }: WeatherIconProps) {
  const iconProps = { size, className };

  const iconMap: Record<string, React.ReactNode> = {
    'clear-day': <WiDaySunny {...iconProps} />,
    'clear-night': <WiNightClear {...iconProps} />,
    'partly-cloudy-day': <WiDayCloudy {...iconProps} />,
    'partly-cloudy-night': <WiNightAltCloudy {...iconProps} />,
    'cloudy': <WiCloudy {...iconProps} />,
    'rain': <WiRain {...iconProps} />,
    'snow': <WiSnow {...iconProps} />,
    'sleet': <WiSleet {...iconProps} />,
    'thunderstorm': <WiThunderstorm {...iconProps} />,
    'fog': <WiFog {...iconProps} />,
    'wind': <WiStrongWind {...iconProps} />,
  };

  return <>{iconMap[icon] || <WiCloudy {...iconProps} />}</>;
}

// Smaller precipitation icon for hourly cards
export function PrecipIcon({ isSnow, className = '' }: { isSnow?: boolean; className?: string }) {
  if (isSnow) {
    return <WiSnowflakeCold className={className} />;
  }
  return <WiRain className={className} />;
}
